var map = {
	"./codepen.svg": 7046,
	"./deviantart.svg": 9044,
	"./github.svg": 2405,
	"./racetime.svg": 6147,
	"./src.png": 1538,
	"./tumblr.svg": 6042,
	"./twitch.svg": 4726,
	"./youtube.svg": 1242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;